import React, { useEffect, useState } from 'react';
import LoginInput from '../components/inputs/LoginInput';
import { useNavigate, useLocation } from "react-router-dom";
import '../App.scss';
import { passwordValidation } from '../functions/Validation';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

export default function ChangePasswordForm(props: any) {
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    props.setCurrentPage(0);
    props.setSidebarVisibility(false);
    const navigate = useNavigate();
    const [currentPassword, setCurrentPassword] = useState('');
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [error, setError] = useState<string | null>(null);
    const userData = localStorage.getItem('userData') ? JSON.parse(localStorage.getItem('userData') as string) : null;
    const [loading, setLoading] = useState(false);
    const [validationFail, setValidationFail] = useState(false);

    useEffect(() => {
        !userData && navigate('/Login')
    }, [navigate])

    const changePassword = async (e: React.FormEvent) => {
        setLoading(true);
        e.preventDefault();
        setError(null);       

        if (!validate()) {
            try {
                const token = encodeURIComponent(userData.token) || '';
                fetch(`${apiBaseUrl}Admin/ChangePassword`, {
                    method: 'POST',
                    headers: {
                        'Authorization': `Bearer ${userData.token}`,
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({
                        currentPassword: currentPassword,
                        password: newPassword,
                        confirmPassword: confirmPassword
                    }),
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.success) {
                            navigate('/YourAccount')
                        } else {
                            setError(result.message || 'An Error occured. Please check your current password.');
                            setLoading(false);
                        }

                    });
            } catch (err) {
                setError('An error occurred. Please try again later.');
                setLoading(false);
            }
        }
        else {
            setLoading(false);
            setValidationFail(true);
        }
    };

    const validate = () => {
        if (!currentPassword || !newPassword || !confirmPassword) {
            return true;
        }
        if (!passwordValidation(newPassword)) {
            return true;
        }
        if (confirmPassword !== newPassword) {
            return true;
        }
        return false;
    }

    const updateCurrentPassword = (e: React.ChangeEvent<HTMLInputElement>) => {
        setCurrentPassword(e.target.value)
    };
    const updateNewPassword = (e: React.ChangeEvent<HTMLInputElement>) => {
        setNewPassword(e.target.value)
    };
    const updateConfirmPassword = (e: React.ChangeEvent<HTMLInputElement>) => {
        setConfirmPassword(e.target.value)
    };

    return (
        <div className="login-form-wrapper">
            <form className="login-form" onSubmit={changePassword}>
                <p className="notification-title">Change Password</p>
                <LoginInput
                    label="Current Password"
                    type="password"
                    placeholder="Enter your current password"
                    validate={(value: string) => (value ? null : 'Password is required')}
                    onChange={updateCurrentPassword}
                    disabled={loading}
                    submitError={validationFail && !currentPassword ? 'Password is required' : null}
                />
                <br />
                <LoginInput
                    label="New Password"
                    type="password"
                    placeholder="Enter your new password"
                    validate={(value: string) => (value ? null : 'Password must be at least 6 characters')}
                    onChange={updateNewPassword}
                    disabled={loading}
                    submitError={validationFail && !passwordValidation(newPassword) ? 'Password must be at least 6 characters' : null}
                />
                <br />
                <LoginInput
                    label="Confirm Password"
                    type="password"
                    placeholder="Confirm your new password"
                    validate={(value: string) => !value ? 'Please confirm your password' : value !== newPassword ? 'Passwords do not match' : null}
                    onChange={updateConfirmPassword}
                    disabled={loading}
                    submitError={validationFail && !confirmPassword ? 'Please confirm your password' : validationFail && confirmPassword !== newPassword ? 'Passwords do not match' : null}
                />
                <br />
                <div className="btn-container">
                    <button className="btn back" onClick={() => navigate('/YourAccount') }>Back: Your Account</button>
                    {loading && <button disabled className="btn loading" type="submit">Saving <FontAwesomeIcon icon={faSpinner} spinPulse /></button> ||
                        <button className="btn primary" type="submit">Save</button>}
                </div>
                {error && <p className="error-message">{error}</p>}
            </form>
        </div>
    );
};

